import { FC } from 'react'
import { GetServerSideProps } from '../../redux/types'
import { BaseTransport } from '../../transports'
import { PageProps, ResponseLocals } from '../../common/types'
import { pageClient } from '../../clients'
import SearchResultListingPageTransport from '../../transports/search-result-listing-page-transport'
import { getMessagesFromLanguage } from '../../i18n/utils'
import { getRoutesFromDomain } from '../../routes/utils'
import { modifyCanonicalOptionally } from '../../utils/seo-utils'
import { deleteSession } from '../../utils/delete-session'
import SearchResultListingPage from '../../components/search-result-listing/list'
import SearchResultListingHead from '../../components/search-result-listing/list/head'
import { getRelativeURL } from '../../utils/encoding-utils'

type Props = {
    baseResponseSearchResultListingPage: BaseTransport<SearchResultListingPageTransport>
} & PageProps

const SearchResultListingContainer: FC<Props> = ({ baseResponseSearchResultListingPage }) => {
    const searchResultListingData = baseResponseSearchResultListingPage?.data

    if (!searchResultListingData) {
        return null
    }

    const siteRelativeURL = getRelativeURL('', { encoded: false })
    const filter = getRelativeURL('', { encoded: true })

    return (
        <>
            <SearchResultListingHead />
            <SearchResultListingPage data={searchResultListingData} siteRelativeURL={siteRelativeURL} filter={filter} />
        </>
    )
}

export const getServerSideProps: GetServerSideProps<Props> = async ({ req, res }) => {
    const { user, device } = res.locals as ResponseLocals

    const data = await pageClient.getSearchResultListingPage({ user })

    if (data.status === 404) {
        return {
            notFound: true,
        }
    }

    modifyCanonicalOptionally(req, data)
    const requestUserConfig = deleteSession(user)

    return {
        props: {
            baseResponseSearchResultListingPage: data,
            device,
            requestUserConfig: requestUserConfig,
            messages: await getMessagesFromLanguage(user.language),
            routes: await getRoutesFromDomain(user.domain),
        },
    }
}

export default SearchResultListingContainer
